/**
 * Ravinaaz Product Information Page (PDP) Image Hover Zoom
 * Smoothly magnifies product image following mouse cursor position.
 */

(function () {
  'use strict';

  function initPdpHoverZoom() {
    // Target all product media image containers
    const containers = document.querySelectorAll('.product-media-container');

    containers.forEach((container) => {
      // Prevent double binding
      if (container.dataset.zoomInitialized === 'true') return;
      container.dataset.zoomInitialized = 'true';

      const img = container.querySelector('.product__media img');
      if (!img) return;

      container.addEventListener('mouseenter', function () {
        container.classList.add('is-zooming');
      });

      container.addEventListener('mousemove', function (e) {
        const rect = container.getBoundingClientRect();
        if (rect.width === 0 || rect.height === 0) return;

        // Calculate cursor position in percentages (0% to 100%)
        const x = Math.max(0, Math.min(100, ((e.clientX - rect.left) / rect.width) * 100));
        const y = Math.max(0, Math.min(100, ((e.clientY - rect.top) / rect.height) * 100));

        img.style.transformOrigin = `${x.toFixed(2)}% ${y.toFixed(2)}%`;
      });

      container.addEventListener('mouseleave', function () {
        container.classList.remove('is-zooming');
        setTimeout(() => {
          if (!container.classList.contains('is-zooming')) {
            img.style.transformOrigin = 'center center';
          }
        }, 250);
      });
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPdpHoverZoom);
  } else {
    initPdpHoverZoom();
  }

  // Re-initialize on dynamic events (Shopify section load, variant change, slide change)
  document.addEventListener('shopify:section:load', initPdpHoverZoom);
  document.addEventListener('variant:change', function () {
    setTimeout(initPdpHoverZoom, 200);
  });

  // Observe gallery slider changes
  const galleryObserver = new MutationObserver(function () {
    initPdpHoverZoom();
  });

  document.querySelectorAll('media-gallery').forEach((gallery) => {
    galleryObserver.observe(gallery, { childList: true, subtree: true });
  });
})();
